import React from 'react';
import { Flex, Text, Button, Image, Heading } from 'rebass';
import { EMPLOYER, RECRUITER } from 'constants/index';
import styled from 'styled-components';
import bookmarkIcon from 'assets/icons/bookmark.png';
import filledBookmarkIcon from 'assets/icons/filledBookmark.png';
import candidate from 'assets/icons/candidate.png';
import addCandidate from 'assets/icons/addCandidate.png';
import infoIcon from 'assets/icons/info.png';
import editIcon from 'assets/icons/edit.png';
import rejectIcon from 'assets/icons/reject.png';
import shareIcon from 'assets/icons/share.png';
import Link from 'components/Link';
import colors from 'theme/colors';
import useModal from 'hooks/useModal';
import Tooltip, { TooltipText } from 'components/Tooltip';
import useJobPostNavigation from '../hooks/useJobPostNavigation';
import useJobPost from '../hooks/useJobPost';

const Wrapper = styled(Flex)`
  border-bottom: 2px solid ${colors.darkGray};
`;

const HeadingButton = styled(Button)`
  cursor: pointer;
  outline: none;
  user-select: none;
`;

const JobPostDetailsNavigation: React.FC<any> = ({ userRole, userJobPost }): JSX.Element => {
  const { openModalHandler } = useModal();
  const { deleteJobPostHandler } = useJobPost(userJobPost.id);
  const {
    saveRecruiterJobPostHandler,
    getShareLinkHandler,
    deleteRecruiterJobPostHandler,
  } = useJobPostNavigation(userJobPost.id);
  return (
    <Flex>
      {userRole === EMPLOYER && (
        <Wrapper width="100%" justifyContent="space-between" alignItems="center" pb={5} mb={4}>
          <Link to="/job-posts" color={colors.lightGreen} hover={colors.lightGreen}>
            <Flex>
              <Text fontSize="24px">{'< Back to '}</Text>
              <Text fontSize="24px" fontWeight={6}>
                Jobs
              </Text>
            </Flex>
          </Link>
          <Flex>
            <HeadingButton
              fontSize="24px"
              fontWeight={6}
              color="lightGreen"
              bg="transparent"
              px={0}
              py={0}
              mr={3}
            >
              <Link to={`/job-post/edit/${userJobPost.id}`} color={colors.lightGreen}>
                <Flex alignItems="center">
                  <Image src={editIcon} mr={1} width={27} />
                  <Text fontSize="24px" fontWeight={6} color="lightGreen">
                    Edit
                  </Text>
                </Flex>
              </Link>
            </HeadingButton>
            <HeadingButton
              fontSize="24px"
              fontWeight={6}
              color="lightGreen"
              bg="transparent"
              px={0}
              py={0}
              onClick={openModalHandler({
                title: 'confirm',
                data: {
                  title: 'Are you sure that you want to delete this job',
                  confirmHandler: deleteJobPostHandler,
                },
              })}
            >
              <Flex alignItems="center">
                <Image src={rejectIcon} mr={1} />
                <Text fontSize="24px" fontWeight={6} color="lightGreen">
                  Delete
                </Text>
              </Flex>
            </HeadingButton>
          </Flex>
        </Wrapper>
      )}
      {userRole === RECRUITER && (
        <Wrapper width="100%" flexDirection="column" pb={3}>
          <Flex width="100%" justifyContent="space-between" alignItems="center" mb={7}>
            <Link to="/job-posts/all" color={colors.lightGreen} hover={colors.lightGreen}>
              <Flex>
                <Text fontSize="24px">{'< Back to '}</Text>
                <Text fontSize="24px" fontWeight={6}>
                  Jobs
                </Text>
              </Flex>
            </Link>
            {!userJobPost.saved && (
              <Flex onClick={saveRecruiterJobPostHandler} css="cursor: pointer">
                <Image src={bookmarkIcon} mr={2} />
                <Text fontSize="24px" fontWeight={6} color="lightGreen">
                  Save
                </Text>
              </Flex>
            )}
            {userJobPost.saved && (
              <Flex onClick={deleteRecruiterJobPostHandler} css="cursor: pointer">
                <Image src={filledBookmarkIcon} mr={2} />
                <Text fontSize="24px" fontWeight={6} color="lightGreen">
                  Saved
                </Text>
              </Flex>
            )}
          </Flex>
          <Flex width="100%" justifyContent="space-between" alignItems="center">
            <Tooltip>
              <Flex alignItems="center">
                <Image src={infoIcon} mr={2} />
                <Text fontSize="18px" fontWeight={6} color="lightGreen">
                  View company details
                </Text>
              </Flex>
              <TooltipText id="tooltipText" width="600px" padding="50px" top="50px" left="-100px">
                <Heading>{userJobPost.companyName}</Heading>
                <Text>Text</Text>
              </TooltipText>
            </Tooltip>
            <Flex width="100%" justifyContent="space-between" css="max-width: 520px;">
              <Flex alignItems="center">
                <Image src={candidate} mr={2} />
                <Text fontSize="24px">{userJobPost.candidateCount || '0'}/5</Text>
              </Flex>
              <Link to={`/add-candidate/${userJobPost.id}`}>
                <Flex alignItems="center">
                  <Image src={addCandidate} mr={2} />
                  <Text fontSize="18px" fontWeight={6} color="lightGreen">
                    Add a candidate
                  </Text>
                </Flex>
              </Link>
              <HeadingButton
                fontSize="24px"
                fontWeight={6}
                color="lightGreen"
                bg="transparent"
                px={0}
                py={0}
                onClick={getShareLinkHandler}
              >
                <Flex alignItems="center">
                  <Image src={shareIcon} mr={2} />
                  <Text fontSize="18px" fontWeight={6} color="lightGreen">
                    Share a link
                  </Text>
                </Flex>
              </HeadingButton>
            </Flex>
          </Flex>
        </Wrapper>
      )}
    </Flex>
  );
};

export default JobPostDetailsNavigation;
